import { match as matchDiscoverRoute } from "@faire/web-api--source/routes/discover/searchTerm/match";
export var matchDiscoverPageRoute = function(pathname, search) {
    if (!pathname.endsWith("/")) {
        pathname += "/";
    }
    return matchDiscoverRoute("".concat(pathname).concat(search));
};
